
document.addEventListener('DOMContentLoaded', () => {

  // BLASTZY PRODUCT IMAGE GALLERY
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-to]')];

    if (!slides.length) return;

    const show = index => {
      slides.forEach((slide, n) => {
        slide.classList.toggle('is-active', n === index);
      });

      thumbs.forEach((thumb, n) => {
        thumb.classList.toggle('is-active', n === index);
        thumb.setAttribute('aria-pressed', String(n === index));
      });
    };

    thumbs.forEach((button, index) => {
      button.addEventListener('click', () => show(index));
    });

    let touchStart = 0;

    const stage = gallery.querySelector('.gallery-stage');

    stage?.addEventListener('touchstart', event => {
      touchStart = event.touches[0].clientX;
    }, { passive: true });

    stage?.addEventListener('touchend', event => {
      const delta = event.changedTouches[0].clientX - touchStart;

      if (Math.abs(delta) > 45) {
        const current = slides.findIndex(slide =>
          slide.classList.contains('is-active')
        );

        const next = (
          current + (delta < 0 ? 1 : -1) + slides.length
        ) % slides.length;

        show(next);
      }
    }, { passive: true });
  });


  // STICKY BUTTON — SCROLL TO KACHING BUNDLES
  const stickyButton = document.querySelector('[data-scroll-buy]');

  stickyButton?.addEventListener('click', () => {
    const target =
      document.querySelector('.blastzy-bundle-app') ||
      document.querySelector('#blastzy-product-form');

    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });


  // STICKY PURCHASE BAR VISIBILITY
  const form = document.querySelector('#blastzy-product-form');
  const sticky = document.querySelector('[data-sticky-buy]');

  if (form && sticky && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      sticky.classList.toggle(
        'visible',
        !entries[0].isIntersecting
      );
    }, {
      threshold: 0
    });

    observer.observe(form);
  }

});
